import React from "react";
import "./CTASection.css";
import { useTranslation } from "react-i18next";

function CTASection({ setActiveTab }) {
  const { t } = useTranslation();

  return (
    <div className="cta-container">
      <button onClick={() => setActiveTab("join-club")} className="club-btn">
        {t("cta_section.button")}
      </button>
      <div className="btn-reflection"></div>
    </div>
  );
}

export default CTASection;
